module.exports = __webpack_public_path__ + "static/media/icon-cleaning-quality.67edc023.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-cleaning-quality.svg
// module id = 729
// module chunks = 0